var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "changepassword"
  }, [_c('div', {
    staticClass: "col-lg-7",
    staticStyle: {
      "margin-left": "20%"
    }
  }, [_c('b-card', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('fieldset', [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.loading
    },
    on: {
      "update:active": function($event) {
        _vm.loading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Old Password")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-lock'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|passValue'),
      expression: "'required|passValue'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('oldpassword')
    },
    attrs: {
      "type": "password",
      "placeholder": "Enter old password",
      "name": "oldpassword",
      "id": "oldpassword"
    },
    model: {
      value: (_vm.oldpassword),
      callback: function($$v) {
        _vm.oldpassword = $$v
      },
      expression: "oldpassword"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('oldpassword')),
      expression: "errors.has('oldpassword')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('oldpassword')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("New Password")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-lock'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|verify_password|verify_OldandNewPassword'),
      expression: "'required|verify_password|verify_OldandNewPassword'"
    }],
    ref: "newpassword",
    class: {
      'form-control': true, 'error': _vm.errors.has('newpassword')
    },
    attrs: {
      "type": "password",
      "pattern": "(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}",
      "title": "Must contain at least one number, one special character, one uppercase and lowercase letter and at least 8 or more characters",
      "placeholder": "Enter new password",
      "name": "newpassword",
      "id": "newpassword"
    },
    model: {
      value: (_vm.newpassword),
      callback: function($$v) {
        _vm.newpassword = $$v
      },
      expression: "newpassword"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('newpassword')),
      expression: "errors.has('newpassword')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('newpassword')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Confirm Password")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-lock'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|confirmed:newpassword'),
      expression: "'required|confirmed:newpassword'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('confirmpassword')
    },
    attrs: {
      "type": "password",
      "placeholder": "Enter confirm password",
      "name": "confirmpassword",
      "id": "confirmpassword",
      "data-vv-as": "confirmpassword"
    },
    model: {
      value: (_vm.confirmpassword),
      callback: function($$v) {
        _vm.confirmpassword = $$v
      },
      expression: "confirmpassword"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('confirmpassword')),
      expression: "errors.has('confirmpassword')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('confirmpassword')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rolefooter form-actions"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "reset",
      "size": "sm"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "size": "sm"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancel")])])], 1)])], 1)])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d30b31c","hasScoped":true}!./src/views/components/changepassword/changepassword.component.html
// module id = 838
// module chunks = 2